import { ErrorStringFromException, isNullOrUndefined } from "../../utils/utils";
import { AuthError, AuthErrors } from "../office-js/auth/AuthErrors";

export enum AuthEnvironment {
    PPE,    // Pre-Production Environment
    Prod,    // Production
    GCC,      // Gcc moderate users
    GCCHigh,  // Gcc High users
    DOD       // DoD users
}

export enum IdentityType {
    ODP = "MicrosoftAccount", /*Personal Accounts*/
    ODB = "OrganizationAccount"/* Enterprise Accounts */,
    Unsupported = "Unsupported" /*Unsupported Accounts*/
}

export interface PrimaryIdentityInfo {
    type: IdentityType,
    displayName : string,
    email : string
}

export type UIAuthProvider=(getAccessToken: ()=>Promise<any>)=>Promise<any>;

export interface IAuthenticationProvider {
    Authenticate(): void;
    GetAccessToken(resource: string): Promise<string>;
    GetAuthEnvironment(): AuthEnvironment;
    SetUIAuthProvider(uiAuthProvider: UIAuthProvider): void;
}

export function CheckAndThrowCannotGetAuthContextError(error: any) {
  if (!isNullOrUndefined(error) && error.code == 'CannotGetAuthContext') {
    throw new AuthError(AuthErrors.CannotGetAuthContext, ErrorStringFromException(error));
  }
}